import { Sparkle } from '@phosphor-icons/react';
import type { FC } from 'react';
import styles from './AgentThinkingIndicator.module.css';

interface Props {
    statusText?: string;
}

const AgentThinkingIndicator: FC<Props> = ({ statusText }) => (
    <div className={styles.wrap}>
        <div className={styles.anchorWrap}>
            <Sparkle size={10} weight="fill" color="#6366f1" />
            <span className={styles.anchorLabel}>Reparo AI</span>
        </div>
        <div className={styles.dotsRow}>
            <div className={styles.dots}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
            </div>
            {statusText && (
                <span className={styles.statusLabel}>{statusText}</span>
            )}
        </div>
    </div>
);

export default AgentThinkingIndicator;
